import React from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import ProductController from "../controllers/ProductController";
import { TCoproducerPagination, TCoproducerStatus } from "../types/Coproducer";

export interface ICoproducerProp {
    page: number;
    rows: number;
    search?: string;
    status?: TCoproducerStatus;
}

const valueDefault = {
    items: [],
    page: 0,
    rowsPerPage: 0,
    totalPages: 0,
    total: 0,
};

export const useCoproducers = ({ page, rows, search, status }: ICoproducerProp) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<TCoproducerPagination>(valueDefault);
    const [error, setError] = React.useState<string>('');

    const execute = async () => {
        if (!loading) {
            try {
                setLoading(true);

                if (error !== '') {
                    setError('');
                }

                const response = await ProductController.getCoproducer({ page, rows, search, status });
                const responseError = response as IErrorResponse;
                const responseData = response as TCoproducerPagination;

                if (responseError.code) {
                    setError(responseError.error);
                    setData(valueDefault);
                } else {
                    setData(responseData);
                }
            } catch (e) {
                var message = 'Erro não identificado';
                if (typeof e === "string") {
                    message = e.toUpperCase();
                } else if (e instanceof Error) {
                    const err = e as Error;
                    message = err.message;
                }
                setError(message);
            } finally {
                setLoading(false);
            }
        }
    }

    React.useEffect(() => {
        execute();
    }, [page, rows, search, status]);

    const clear = () => {
        setError('');
    }

    return {
        loading,
        data,
        error,
        execute,
        clear,
    };
}